import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { ConsumoMadeira } from '../../types/producao';
import { consumoMadeiraService, lotesMadeiraService, ordensProducaoService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<ConsumoMadeira>[] = [
  {
    name: 'ordem',
    label: 'Ordem de produção',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      ordensProducaoService.list,
      (item: any) => item.codigo ?? String(item.id),
    ),
    required: true,
  },
  {
    name: 'lote',
    label: 'Lote',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      lotesMadeiraService.list,
      (item: any) => item.lote_info ?? `Lote ${item.id}`,
    ),
    required: true,
  },
  { name: 'quantidade_utilizada', label: 'Quantidade utilizada (ton)', type: 'number' },
  { name: 'perda_madeira', label: 'Perda (ton)', type: 'number' },
  { name: 'data_consumo', label: 'Data de consumo', type: 'date' },
  { name: 'observacoes', label: 'Observações', type: 'textarea' },
];

export const ConsumoMadeiraFormPage: React.FC = () => (
  <ResourceFormPage
    title="Consumo de madeira"
    description="Registre o consumo de madeira por ordem."
    fields={fields}
    service={consumoMadeiraService}
    redirectPath="/admin/producao/consumo-madeira"
    cancelPath="/admin/producao/consumo-madeira"
  />
);
